/**
 * Generates a consistent color based on a string input
 * @param string - The input string to generate a color from
 * @returns A hex color string
 */
export function stringToColor(string: string): string {
	let hash = 0;
	let i;

	/* eslint-disable no-bitwise */
	for (i = 0; i < string.length; i += 1) {
		hash = string.charCodeAt(i) + ((hash << 5) - hash);
	}

	let color = "#";

	for (i = 0; i < 3; i += 1) {
		const value = (hash >> (i * 8)) & 0xff;
		const darkValue = Math.floor((value * 150) / 255);
		color += `00${darkValue.toString(16)}`.slice(-2);
	}
	/* eslint-enable no-bitwise */

	return color;
}

/**
 * Generates avatar props for Material-UI Avatar component
 * @param firstName - First name of the user
 * @param lastName - Last name of the user
 * @param size - Size configuration for the avatar (default: 50px)
 * @returns Avatar props object with sx styles and children text
 */
export function stringAvatar(firstName?: string, lastName?: string, size: number = 50) {
	return {
		sx: {
			width: size,
			height: size,
			fontSize: size > 42 ? "1.2rem" : "1rem",
			bgcolor: stringToColor(`${firstName} ${lastName}`)
		},
		children: `${firstName?.[0]?.toUpperCase() ?? ""}${
			lastName?.[0]?.toUpperCase() ?? ""
		}`
	};
}
